// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guess-button {
  background-color: rgb(184, 184, 202);
  opacity: 0.5;
  padding: 10px;
  border-radius: 10px;
  color:white;
  font-weight: bold;
  border:none;
  min-width: 70px;
}

.guess-button.modal {
  width: 50%;
}


.guess-button.guessable {
  background-color: rgb(184, 184, 202);
  opacity: 1;
  border: 2px;
  border-style: solid;
  border-color:rgb(81, 158, 202);
}

.guess-button.guessable:hover {
  opacity: .8;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/GuessButton/GuessButton.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,oCAAoC;EACpC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb","sourcesContent":[".guess-button {\n  background-color: rgb(184, 184, 202);\n  opacity: 0.5;\n  padding: 10px;\n  border-radius: 10px;\n  color:white;\n  font-weight: bold;\n  border:none;\n  min-width: 70px;\n}\n\n.guess-button.modal {\n  width: 50%;\n}\n\n\n.guess-button.guessable {\n  background-color: rgb(184, 184, 202);\n  opacity: 1;\n  border: 2px;\n  border-style: solid;\n  border-color:rgb(81, 158, 202);\n}\n\n.guess-button.guessable:hover {\n  opacity: .8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
